import { eventsTable } from '@/controllers/events-table'
import { dictionary } from '@/controllers/events'

const [route, action] = ['dictionary', 'get-check-address-messages']

export const getCheckAddressMessages = function (callback) {
  window[Symbol.for('vue.prototype')].$sendMessageToWorker({ route, action })

  eventsTable[dictionary[action]] = callback
}
